module.exports = __webpack_public_path__ + "img/HQ-Z7020-V3-all.64e2bb7f.png";